import React, { useState } from 'react'
import { post } from '@rails/request.js'
import { Card, CardContent, CardTitle, CardDescription } from '../ui/Card'

const PROFILE_PAGE_URL = '/my_dashboard?activeTab=profile'
const CREDIT_REPORT_PAGE_URL = '/my_dashboard?activeTab=credit_report'
const CREDIT_REPORT_FETCH_URL = '/my_dashboard/fetch_credit_report'

const CreditReportCTA = () => {
  const [isFetching, setIsFetching] = useState(false)
  const [error, setError] = useState(null)

  const handleFetchCreditReport = async () => {
    setIsFetching(true)

    try {
      const response = await post(CREDIT_REPORT_FETCH_URL)
      const data = await response.json

      if (response.ok && data.success) {
        window.location.href = CREDIT_REPORT_PAGE_URL
      } else {
        setError(true)
      }
    } catch (error) {
      console.error('Error fetching credit report:', error)
      setError(true)
    } finally {
      setIsFetching(false)
    }
  }

  if (error) {
    return (
      <Card id='credit-report-cta-error'>
        <CardContent>
          <CardTitle>
            <h2 className='mb-3'>Sorry, there was an error fetching your credit report.</h2>
          </CardTitle>
          <CardDescription>
            <p className='mb-4'>Please double-check your profile information and try again.</p>

            <a href={PROFILE_PAGE_URL} className='btn btn-primary w-100 mb-3' rel='nofollow'>
              Go to profile
            </a>
          </CardDescription>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card id='credit-report-cta'>
      <CardContent>
        <CardTitle>
          <h2 className='mb-3'>Find hidden debt in collections.</h2>
        </CardTitle>
        <CardDescription>
          <p className='mb-4'>
            Most people being sued for a debt have 4 other accounts in collections. We can help you
            settle every one.
          </p>

          <button
            onClick={handleFetchCreditReport}
            className='btn btn-primary w-100 mb-3'
            disabled={isFetching}
          >
            {isFetching ? 'Fetching...' : 'See my credit report'}
          </button>

          <p className='text-muted small mb-0'>
            This won't affect your credit score. By clicking continue, you agree to a soft-credit
            pull as stated in our Terms of Service.
          </p>
        </CardDescription>
      </CardContent>
    </Card>
  )
}

export default CreditReportCTA
